export const UserSettingsMenu = {
  DownloadAll: {
    name: 'downloadall',
    text: 'Download All',
    icon: 'download'
  },
  DownloadAllInProgress: {
    name: 'downloadallInProgress',
    text: 'Download All (In Progress)',
    icon: 'download',
    disabled: true
  }
};
